import colors1 from "../img/project_imgs/colors/1.png";
import colors2 from "../img/project_imgs/colors/2.png";
import colors3 from "../img/project_imgs/colors/3.png";
import colors4 from "../img/project_imgs/colors/4.png";

import rada1 from "../img/project_imgs/rada/1.png";
import rada2 from "../img/project_imgs/rada/2.png";

import discord1 from "../img/project_imgs/discord/discord.png";

import mileage1 from "../img/project_imgs/mileage/1.png";
import mileage2 from "../img/project_imgs/mileage/2.png";
import mileage3 from "../img/project_imgs/mileage/3.png";

import movies1 from "../img/project_imgs/movies/1.png";
import movies2 from "../img/project_imgs/movies/2.png";
import movies3 from "../img/project_imgs/movies/3.png";

import opinionrated1 from "../img/project_imgs/opinionrated/1.png";
import opinionrated2 from "../img/project_imgs/opinionrated/2.png";

import shopping1 from "../img/project_imgs/shopping/1.png";
import shopping2 from "../img/project_imgs/shopping/2.png";
import shopping3 from "../img/project_imgs/shopping/3.png";

import brochure1 from "../img/project_imgs/brochure/1.jpg";
import brochure2 from "../img/project_imgs/brochure/2.jpg";
import brochure3 from "../img/project_imgs/brochure/3.jpg";
import brochure4 from "../img/project_imgs/brochure/4.jpg";

import fracas1 from "../img/project_imgs/fracas/1.png";
import fracas2 from "../img/project_imgs/fracas/2.png";
import fracas3 from "../img/project_imgs/fracas/3.png";
import fracas4 from "../img/project_imgs/fracas/4.png";
import fracas5 from "../img/project_imgs/fracas/5.png";

const colorsImgs = [colors1, colors2, colors3, colors4];
const discordImgs = [discord1];
const mileageImgs = [mileage1, mileage2, mileage3];
const moviesImgs = [movies1, movies2, movies3];
const opinionratedImgs = [opinionrated1, opinionrated2];
const shoppingImgs = [shopping1, shopping2, shopping3];
const radaImgs = [rada1, rada2];
const brochureImgs = [brochure1, brochure2, brochure3, brochure4];
const fracasImgs = [fracas1, fracas2, fracas3, fracas4, fracas5];

export {
  colorsImgs,
  discordImgs,
  mileageImgs,
  moviesImgs,
  opinionratedImgs,
  shoppingImgs,
  radaImgs,
  brochureImgs,
  fracasImgs,
};
